if (!customElements.get('bg-image-with-popup-video')) {
    customElements.define(
        'bg-image-with-popup-video',
        class BgImageWithPopupVideo extends HTMLElement {
            constructor() {
                super();
                this.addButton = this.querySelector('.bg-image-with-popup-video__add-to-cart');

                this.fullVideoButton = this.querySelector('.bg-image-with-popup-video__watch-video');
                this.fullVideo = this.querySelector('.video-popup__full-video');
                this.fullVideoDialog = this.querySelector('.video-popup__dialog');
                this.dialogCloseArea = this.querySelector('.video-popup__close-area');
                this.dialogCloseButton = this.querySelector('.video-popup__close-button');
                this.flag = false;
                this.fullVideoInstance = null;

                this.videoType = this.getAttribute('data-video-type');

            }

            async connectedCallback() {
                this.addButtonClickFunction();
                const { VidstackPlayer: Player, VidstackPlayerLayout } = await import('https://cdn.vidstack.io/player@v1.11.30');
                // this.initThumbVideo(Player, VidstackPlayerLayout);
                if (this.fullVideoButton) {

                    this.fullVideoButton.addEventListener('click', (event) => {
                        this.initFullVideo(event, Player, VidstackPlayerLayout);
                    });
                    const closeDialogHandler = () => {
                        this.toggleDialog(false);
                        this.fullVideoInstance.pause();
                    };

                    this.dialogCloseArea.addEventListener('click', closeDialogHandler);
                    this.dialogCloseButton.addEventListener('click', closeDialogHandler);
                }
            }

            async initFullVideo(event, VidstackPlayer, VidstackPlayerLayout) {
                if (!this.flag) {
                    this.toggleDialog(true);
                    const title = this.fullVideo.getAttribute('data-title');
                    const videoSrc = this.fullVideo.getAttribute('data-src');
                    const layout = new VidstackPlayerLayout({
                        thumbnails: null,
                    });
                    try {
                        const player = await VidstackPlayer.create({
                            target: this.fullVideo,
                            title: title,
                            controls: true,
                            loop: true,
                            src: videoSrc,
                            muted: true,
                            playsInline: true,
                            autoplay: true,
                            layout
                        });
                        this.flag = true;
                        this.fullVideoInstance = player;
                    } catch (error) {
                        console.error('Error creating player:', error);
                    }
                } else {
                    this.toggleDialog(true, true);
                }
            }


            toggleDialog(status, play) {
                if (status) {
                    this.fullVideoDialog.classList.add('video-popup__dialog--visible');
                    if (play) {
                        this.fullVideoInstance.play();
                    }
                    document.body.style.overflow = 'hidden';
                } else {
                    this.fullVideoDialog.classList.remove('video-popup__dialog--visible');
                    document.body.style.overflow = '';
                }
            }

            addButtonClickFunction() {
                if (this.addButton) {
                    const productInfoElement = document.querySelector('.product-information');
                    if (productInfoElement) {
                        this.addButton.addEventListener('click', () => {
                            productInfoElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            productInfoElement.setAttribute('tabindex', '-1');
                        });
                    }
                }
            }

            disconnectedCallback() {
            }
        }
    );
}
